export const setUSER = "setUSER";
